import React from 'react';

import PropTypes from 'prop-types';

import BlueCheckedCard from '../Svg/BlueCheckedCard';

import './ContractTermOptions.css';

export const ContractTermOptions = (props) => {
  return (
    <div className='ct-options'>
      {props.options.map((option) => {

        const discountMonthValue = option && option.discountTerm ? option.discountTerm.split(' ') : 0;

        return (
          <div className={'ct-card'} key={option.value}>
            <div className={`ct-card-content ${(props.selectedOption === option.value) ? 'ct-card-checked' : ''}`} onClick={() => { props.onChange(option.value) }}>
              <label className='ct-card-label' htmlFor={option.value} >{option.label}</label>
              <label className={`ct-card-price ${option.discountTerm ? 'ct-price-blue' : ''}`} htmlFor={option.value}>R{option.price} PM</label>
              {
                option.discountTerm &&
                <label className='ct-discount' htmlFor={option.value}>R{parseFloat(props.totalPrice) - parseFloat(option.discountAmount)} for {discountMonthValue[0] === '1' ? 'the first month' : `the first ${discountMonthValue[0]} months`}</label>
              }
              {
                (props.selectedOption === option.value)


                  ? <BlueCheckedCard />

                  : null
              }

            </div>
            
            {(props.selectedOption === option.value && !!option.discountTerm)

              ? <div className={'ct-discount ct-discount-blue'} htmlFor={option.value}>ON PROMOTION</div>
              : null
            }

          </div>
        );
      })}
    </div>
  );
}

ContractTermOptions.propTypes = {
  className: PropTypes.string,
  inline: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  selectedOption: PropTypes.string,
  totalPrice: PropTypes.string,
  automationidattr: PropTypes.string
}

